export default function buildViewOfferDetails(draft) {
  const budget = draft?.budget && typeof draft.budget === 'object'
    ? draft.budget
    : draft?.budget || draft?.claims
      ? {
          maxAmount: draft?.budget ? String(draft.budget).replace(/[^0-9.]/g, '') : undefined,
          amountPeriod: undefined,
          maxClick: draft?.claims ? Number(String(draft.claims).replace(/[^0-9]/g, '')) : undefined,
          clickPeriod: undefined,
        }
      : undefined;

  return {
    businessName: draft?.businessName || '',
    type: draft?.type || '',
    fulfillment: draft?.fulfillment || '',
    title: draft?.title || '',
    headline1: draft?.headline1 || '',
    headline2: draft?.headline2 || '',
    description: draft?.description || '',
    offerImage: draft?.offerImage || '',
    keywords: Array.isArray(draft?.keywords) ? draft.keywords : [],
    category: Array.isArray(draft?.category)
      ? draft.category.map((category) => (typeof category === 'string' ? { name: category } : category))
      : [],
    schedule: draft?.schedule,
    startDate: draft?.startDate || '',
    endDate: draft?.endDate || '',
    budget,
    budgetEstimate: draft?.budgetEstimate ?? null,
    unlimitedClaims: draft?.unlimitedClaims === true,
    offerLocation: draft?.offerLocation || (typeof draft?.audience === 'string' && draft.audience
      ? { type: 'CUSTOM', raw: draft.audience }
      : draft?.audience || undefined),
    locationLabel: draft?.locationLabel || '',
    promoCode: draft?.promoCode || draft?.redemption || '',
    barcode: draft?.barcode || '',
    qrCode: draft?.qrCode || '',
    siteUrl: draft?.siteUrl || '',
    termsAndConditions: draft?.termsAndConditions || '',
  };
}
